﻿import classNames from "classnames";
import { FC } from "react";
import type { I18n } from "../../hooks/useTranslations";
import { useI18n } from "../../hooks/useTranslations";
import { isLookup, MenuOptionFilterValue, MenuOptionValue } from "../../types";
import { formatBoolean } from "../../types/utils";
import styles from "./HeaderMenuOption.module.css";

export interface Option {
  value: MenuOptionFilterValue;
  selected?: boolean;
}

export const getOptionLabel = (
  value: MenuOptionFilterValue,
  formatter: ((value: MenuOptionValue) => string | undefined) | undefined,
  i18n: I18n,
): string => {
  const formattedValue = formatter?.(value) ?? value;

  if (formattedValue === null || formattedValue === undefined || formattedValue === "") {
    return `(${i18n.t.common.empty})`;
  }

  if (isLookup(formattedValue)) {
    return formattedValue.value;
  }

  if (formattedValue === true || formattedValue === false) {
    return formatBoolean(i18n.t, formattedValue);
  }

  return formattedValue.toString();
};

interface HeaderMenuOptionProps {
  option: Option;
  updateFilters: (option: Option) => void;
  formatter?: (value: MenuOptionValue) => string | undefined;
  className?: string;
}

const HeaderMenuOption: FC<HeaderMenuOptionProps> = (props: HeaderMenuOptionProps) => {
  const i18n = useI18n();

  const onChange = () => {
    const option: Option = {
      value: props.option.value,
      selected: !props.option.selected,
    };

    props.updateFilters(option);
  };

  const value = getOptionLabel(props.option.value, props.formatter, i18n);

  const optionId = `${Math.random()}`;

  return (
    <label title={`${value}`}>
      <div className={classNames(props.className, styles.option)}>
        <input type="checkbox" id={optionId} checked={props.option.selected} onChange={onChange} />
        <div className={styles.unselectable}>{value}</div>
      </div>
    </label>
  );
};

export default HeaderMenuOption;
